import { useTranslation } from 'react-i18next'
import Gallery from './Gallery/Gallery'

type Graphic = { src: string; city: string; label?: string; author?: string }

// "Download graphics" section: a gallery of downloadable graphics, shown at the bottom of the bank pages.
export function DownloadGraphics({ id, images }: { id: string; images: Graphic[] }) {
  const { t } = useTranslation()

  return (
    <div className='flex flex-col gap-6 w-full max-w-5xl'>
      <div className='flex flex-col gap-3'>
        <h2 className='text-2xl font-bold'>{t('leftBank.downloadTitle')}</h2>
        <p className='opacity-70'>{t('leftBank.downloadSub')}</p>
      </div>
      <Gallery id={id} images={images} downloadable bare />
    </div>
  )
}
